module.exports = __webpack_public_path__ + "images/pages/what-are/vocal-fold-graphics.png";